import React from 'react';
import './AyudaModal.css';

/**
 * Modal de ayuda con instrucciones paso a paso.
 *
 * Props:
 *  - titulo: título del modal (ej: "Ayuda — Rodeo")
 *  - pasos: array de pasos. Cada paso:
 *      { titulo, descripcion (string | string[]), imagen? }
 *    "imagen" es el nombre de archivo dentro de /public/ayuda/ (ej: "rodeo-nuevo.png").
 *  - onClose: callback para cerrar.
 */
export default function AyudaModal({ titulo, pasos = [], onClose }) {
  const imgBase = `${process.env.PUBLIC_URL || ''}/ayuda/`;

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal ayuda-modal">
        <div className="ayuda-header">
          <h2>❓ {titulo}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="ayuda-body">
          {pasos.map((paso, i) => (
            <div className="ayuda-paso" key={i}>
              <div className="ayuda-paso-num">
                <span className="ayuda-paso-icono">{paso.icono || (i + 1)}</span>
                <span className="ayuda-paso-badge">{i + 1}</span>
              </div>
              <div className="ayuda-paso-contenido">
                <h3>{paso.titulo}</h3>
                {Array.isArray(paso.descripcion)
                  ? <ul>{paso.descripcion.map((d, j) => <li key={j}>{d}</li>)}</ul>
                  : <p>{paso.descripcion}</p>}
                {paso.imagen && (
                  <img
                    className="ayuda-img"
                    src={imgBase + paso.imagen}
                    alt={paso.titulo}
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="ayuda-footer">
          <button className="btn-primary" onClick={onClose}>Entendido</button>
        </div>
      </div>
    </div>
  );
}
